import { FileItem, FileUpload, NotificationModal } from '@components/ui';
import { UserFile, UserTopic } from '@dieterApi/user/useUserQuery';
import { useUserValueAddMutation } from '@dieterApi/user/useUserValueAddMutation';
import { useUserValueDeleteMutation } from '@dieterApi/user/useUserValueDeleteMutation';
import { PartnerTableMeta } from './typesAndEnums';

export const SignedContractModal = ({
  topic,
  tableMeta,
  ...props
}: {
  open: boolean;
  onClose: () => void;
  topic: UserTopic;
  tableMeta?: PartnerTableMeta;
}) => {
  const [addUserValue] = useUserValueAddMutation();
  const [deleteUserValue] = useUserValueDeleteMutation();

  const index = tableMeta?.rowData[2] as string;

  const signedContractFile = tableMeta?.rowData[11];

  const handleSignedContractUpload = (file: UserFile) => {
    if (!index) {
      console.error('Index is not defined for signed contract upload');
      return;
    }

    addUserValue({
      variables: {
        key: 'DATA_PROCESSOR_SIGNED_CONTRACT',
        value: file.id,
        index,
      },
    });
  };

  const handleDelete = (file: UserFile) => {
    deleteUserValue({
      variables: {
        key: 'DATA_PROCESSOR_SIGNED_CONTRACT',
        index,
      },
    });
  };

  return (
    <NotificationModal {...props}>
      <div className="flex flex-col gap-4 p-8">
        <h3 className="font-medium text-xl">Unterschriebenen Vertrag verwalten</h3>

        {signedContractFile ? (
          <p className="mt-6">
            <strong>Unterschriebener Vertrag:</strong>
            <FileItem file={signedContractFile} withActions={true} onDelete={handleDelete} topicId={topic.id} />
          </p>
        ) : (
          <>
            <div className="">Hier kannst du den unterschriebenen Vertrag hochladen:</div>
            {index && <FileUpload topicId="topic-av" onComplete={handleSignedContractUpload} />}
          </>
        )}
      </div>
    </NotificationModal>
  );
};
